import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import vClickOutside from "click-outside-vue3"

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./pages/${name}`),
  setup({ el, app, props, plugin }) {
    createApp({ render: () => h(app, props) })
      .use(plugin)
      .use(vClickOutside)
      .mixin({
        methods: {
          $route: window.route,
        },
      })
      .mount(el)
  },
})
